import React, { useState } from "react";
import { NodeSection } from "../../NodeUI";
import "./Dialogs/WorkflowPublishConfirmDialog.css";

function WorkflowPublishComment({ setPublishComment }) {
  const [comment, setComment] = useState("");

  return (
    <NodeSection title="Version notes (optional)">
      <textarea
        className="publish-comment-textarea"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        onBlur={() => setPublishComment(comment)}
        placeholder="Add notes describing changes in this version..."
        maxLength={500}
      />
    </NodeSection>
  );
}

export default WorkflowPublishComment;
